module.exports = __webpack_public_path__ + "img/zh-CN.4f4b629.png";